export default __webpack_public_path__ + "static/media/GT-Walsheim-Pro-Regular.2c0f3c9b.ttf";